import React, { useEffect, useRef, useState } from 'react';

const stats = [
  { num: 150, suffix: '+', label: 'familias confiaron en nosotros' },
  { num: 5, suffix: ' años', label: 'desarrollando en Pachuca' },
  { num: 24, suffix: '/7', label: 'vigilancia y control de acceso' },
  { num: 100, suffix: '%', label: 'aceptación INFONAVIT y bancos' },
];

const banks = [
  { src: '/images/logos-creditos-1.png', alt: 'Bancos aliados' },
  { src: '/images/logos-creditos-2.png', alt: 'INFONAVIT FOVISSSTE' },
];

function useCounter(target, inView, duration = 1400) {
  const [val, setVal] = useState(0);
  useEffect(() => {
    if (!inView) return;
    let raf, start;
    const step = (t) => {
      if (!start) start = t;
      const p = Math.min((t - start) / duration, 1);
      setVal(Math.floor(p * target));
      if (p < 1) raf = requestAnimationFrame(step);
    };
    raf = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf);
  }, [target, inView, duration]);
  return val;
}

function StatItem({ num, suffix, label, inView, idx }) {
  const v = useCounter(num, inView);
  return (
    <div className="trust-stat" data-testid={`trust-stat-${idx}`}>
      <div className="trust-stat-num">
        <span>{v}</span>
        <span className="trust-stat-suffix">{suffix}</span>
      </div>
      <div className="trust-stat-label">{label}</div>
    </div>
  );
}

export default function TrustBand() {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const obs = new IntersectionObserver(
      ([e]) => { if (e.isIntersecting) { setInView(true); obs.disconnect(); } },
      { threshold: 0.25 }
    );
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);

  return (
    <section className="trust-band" ref={ref} data-testid="trust-band">
      <div className="page-padding">
        <div className="container-large">
          <div className="trust-stats-row">
            {stats.map((s, i) => (
              <StatItem key={i} idx={i} inView={inView} {...s} />
            ))}
          </div>
          <div className="trust-divider" />
          <div className="trust-banks">
            <div className="trust-banks-label">Aliados financieros</div>
            <div className="trust-banks-logos">
              {banks.map((b, i) => (
                <img loading="lazy" key={i} src={b.src} alt={b.alt} className="trust-bank-logo" />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
